/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { MapPin, Clock, ArrowLeft } from 'lucide-react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useColectivos } from '../../hooks/useColectivos';
import { ErrorMessage } from '../ErrorMessage';
import { ENDPOINTS } from '../../constants/endpoints';
import { getStopByStopId } from '../../utils/localStorage';
import getColorByLine from '../../constants/colorsByLine';
import { Home, RefreshCw } from 'lucide-react';

export const StopScreen = () => {
  const { stopId } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [stop, setStop] = useState(state?.stop || null);
  const { colectivos, cargando, error, obtenerColectivos } = useColectivos();

  // Determinar el endpoint y body basado en la línea guardada
  const getEndpointAndBody = () => {
    const line = stop?.line;
    const body = { idParada: stopId.trim(), codLinea: '0' };
    
    if (line === 'unionplatense') {
      return { endpoint: ENDPOINTS.unionplatense, body };
    } else if (line === 'linea7') {
      return { endpoint: ENDPOINTS.linea7, body };
    } else {
      // Default: intentar primero unionplatense
      return { endpoint: ENDPOINTS.unionplatense, body };
    }
  };

  const [endpointData, setEndpointData] = useState(getEndpointAndBody());

  useEffect(() => {
    if (state?.stop) {
      setStop(state.stop);
    } else {
      const foundStop = getStopByStopId(stopId);
      if (foundStop) {
        setStop(foundStop);
      }
    }
  }, [state]);

  useEffect(() => {
    const newEndpointData = getEndpointAndBody();
    setEndpointData(newEndpointData);
    obtenerColectivos(newEndpointData.endpoint, 'POST', newEndpointData.body);
  }, [stopId]);

  return (
    <div className="min-h-screen bg-gray-50 pb-6">
      <div className="bg-blue-600 text-white p-6 shadow-lg">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 mb-4 hover:opacity-80 transition"
        >
          <ArrowLeft className="w-5 h-5" />
          Volver
        </button>

        <h2 className="text-2xl font-bold flex items-center gap-2 mb-4">
          <MapPin className="w-6 h-6" />
          {stop?.stopName ? `${stop.stopName} (${stop.stopId})` : `Parada ${stopId}`}
        </h2>
      </div>
      
      <div className="p-4">

        <div className='flex justify-end pb-4'>
          <div className='text-right flex items-center gap-4'>
            <button
              onClick={() => navigate('/')}
              className="bg-lime-600 hover:bg-lime-700 text-white font-semibold py-3 px-6 rounded-xl transition duration-200 flex items-center justify-center gap-2 mx-auto shadow-lg"
            >
              <Home className="w-5 h-5" />
            </button>
            <button
              onClick={() => obtenerColectivos(endpointData.endpoint, 'POST', endpointData.body)}
              className="bg-lime-600 hover:bg-lime-700 text-white font-semibold py-3 px-6 rounded-xl transition duration-200 flex items-center justify-center gap-2 mx-auto shadow-lg"
            >
              <RefreshCw className="w-5 h-5" />
            </button>
          </div>
        </div>

        {cargando ? (
          <div className="flex justify-center items-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          </div>
        ) : error ? (
          <ErrorMessage 
            message={error}
            onReintentar={() => obtenerColectivos(endpointData.endpoint, 'POST', endpointData.body)}
          />
        ) : (
          <div className="space-y-3">
            {colectivos.map((colectivo) => (
              <div
                key={colectivo.id}
                className="bg-white rounded-xl shadow-md p-4 flex items-center justify-between hover:shadow-lg transition"
              >
                <div className="flex items-center gap-4">
                  <div 
                    style={{ backgroundColor: getColorByLine(colectivo.linea) }}
                    className="text-white rounded-lg w-14 h-14 flex items-center justify-center font-bold text-lg"
                  >
                    {colectivo.linea}
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">{colectivo.destino}</p>
                    <p className="text-sm text-gray-500">Línea {colectivo.descripcionLinea}</p>
                  </div>
                </div>
                <div className="text-right">
                  <div className="flex items-center gap-2 text-green-600 font-bold">
                    <Clock className="w-5 h-5" />
                    {colectivo.tiempo}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};